import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = () => {
  const location = useLocation();

  const pathToTitle = useMemo(() => ({
    "/": "Home | SLGT Marketing Agency",
    "/aboutus": "About Us | SLGT Marketing Agency",
    "/services": "Services | SLGT Marketing Agency",
    "/services/seo": "SEO Services | SLGT Marketing Agency",
    "/services/social-media-marketing": "Best Social Media Marketing Company in Anakapalli & Visakhapatnam | SLGT Digital",
    "/services/google-ads": "Google Ads | SLGT Marketing Agency",
    "/services/website-designing": "Best Website Designing Company in Anakapalli & Visakhapatnam | SLGT Digital",
    "/services/app-development": "Best App Development Company in Anakapalli & Visakhapatnam | SLGT Digital",
    "/services/influencer-marketing": "Influencer Marketing | SLGT Marketing Agency",
    "/services/whatsapp-marketing": "WhatsApp Marketing | SLGT Marketing Agency",
    "/services/orm": "Online Reputation Management | SLGT Marketing Agency",
    "/services/pr-agency": "PR Agency | SLGT Marketing Agency",
    "/services/email-marketing": "Email Marketing | SLGT Marketing Agency",
    "/blog": "Blog | SLGT Marketing Agency",
    "/contact": "Contact Us | SLGT Marketing Agency",
    "/company": "Company | SLGT Marketing Agency",
    "/pricing": "Pricing | SLGT Marketing Agency",
    "/careers": "Careers | SLGT Marketing Agency",
    "/faqs": "FAQs | SLGT Marketing Agency",
    "/privacy-policy": "Privacy Policy | SLGT Marketing Agency",
    "/sitemap": "Sitemap | SLGT Marketing Agency",
    "/requestquotes": "Request a Quote | SLGT Marketing Agency",
  }), []);

  useEffect(() => {
    let title = pathToTitle[location.pathname];

    // Individual blog posts set their own title/meta via Helmet — don't fight it.
    if (!title && location.pathname.startsWith("/blog/")) {
      return;
    }

    document.title = title || "SLGT Marketing Agency";
  }, [location.pathname, pathToTitle]);

  return null;
};

export default PageTitle;
